import { MobileDayView } from '../components/mobile/MobileDayView'

export function MobileWeekPage() {
  return <MobileDayView />
}
